<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0)">
  <path d="M8.40001 18H17.1C17.6 18 17.9 17.4 17.9 16.8V8.4C17.9 8 17.6 7.6 17.3 7.6H7.70001V16.8C7.70001 17.6 7.90001 18 8.40001 18Z" fill="#868686" />
  <path d="M14.2 8.7H9V11.7H14.2V8.7Z" fill="#B8B8B8"/>
  <path d="M16.1 16.9V7.6V7.1C16.1 6.5 15.7 6.1 15.3 6.1L7.8 6C7.4 6 7 6.5 7 7V15.1V16.7C7 17.4 7.5 18 8.1 18H15.7H16.8C16.3 18 16.1 17.6 16.1 16.9ZM14.6 14.5H8.5C8.2 14.5 8 14.3 8 14C8 13.7 8.2 13.5 8.5 13.5H14.7C15 13.5 15.2 13.7 15.2 14C15.1 14.3 14.9 14.5 14.6 14.5ZM15.1 12.2C15.1 12.5 14.9 12.7 14.6 12.7H8.5C8.2 12.7 8 12.5 8 12.2V8.2C8 7.9 8.2 7.7 8.5 7.7H14.7C15 7.7 15.2 7.9 15.2 8.2V12.2H15.1Z" fill="#B8B8B8" />
</g>
<defs>
  <clipPath id="clip0">
    <rect width="10.9" height="12" fill="white" transform="translate(7 6)"/>
  </clipPath>
</defs>
</svg>
